<template>
  <div>
    <button class="mylisting-button dark-button" @click="showAddAdminModal()">Add Administrator</button>
    <table class="table table-striped mt-2">
      <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
        <tr class="">
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">Classification</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in agents" :key="user.id" @click="showAgentModal(user)" style="cursor: pointer;">
        <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="deleteUser(user.id)" style="cursor: pointer;"> -->
          <td>
            {{ user.first_name }} {{ user.last_name }}
          </td>
          <td>
            {{ user.email }}
            <!-- {{ user.status }} -->
          </td>
          <td>
            {{ user.category }}
            <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
            <!-- <button class="btn btn-danger" @click="setteam(user)">Set Team Status</button> -->
            <!-- <button class="mylisting-button dark-button" @click="unadminify(user)">Unadminify</button> -->
            <!-- <button class="mylisting-button dark-button" @click="setCategory(user)">Set Category</button> -->
            <!-- <button class="mylisting-button dark-button" @click="setPassword(user)">Set Password</button> -->
          </td>
        </tr>
      </tbody>
    </table>

    <modal name="admin-panel-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">

        <div class="row" style="margin-bottom: 30px;">
          <div class="col dashboard-button text-center" :class="{ 'dashboard-button-active': tab == 'admin' }" @click="tab = 'admin'">
            Admin
          </div>
        </div>

        <div>
          <panel :passedUser="agent" @userUpdated="userUpdated()"></panel>
        </div>

        <hr>
          <button class="mylisting-button danger-button" @click="showDeleteUserModal(agent)">Delete</button>
      </div>
    </modal>

    <modal name="add-admin-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h2>Add Admin</h2>
        <hr>
        <label class="top-label">Email*</label>
        <input type="text" class="form-control" v-model="email">
        <label class="">First Name</label>
        <input type="text" class="form-control" v-model="firstName">
        <label class="">Last Name</label>
        <input type="text" class="form-control" v-model="lastName">
        <label>Access Level*</label>
        <multiselect
          class="mb-2 w-100"
          v-model="category"
          :options="categories"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Select Access Level"
          :max-height= "150"
        ></multiselect>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('agent-modal')">Cancel</button>
        <button class="mylisting-button dark-button" @click="addAdmin()" v-if="email && category" style="float: right;">Add</button>
      </div>
    </modal>

    <modal name="delete-agent-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Are you sure you want to delete this user?</h3>
        <!-- <p>{{ user.first_name }} {{ user.last_name }}</p> -->
        <p>{{ agent.email }}</p>
        <hr>
        <button class="mylisting-button secondary-button" @click="hideDeleteUserModal()" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteUser(agent)" style="float: right;">Delete</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import Panel from '../Panel'

export default {
  components: {
    Panel,
  },
  data() {
    return {
      agents: {},
      agent: {},
      tab: '',

      email: '',
      firstName: '',
      lastName: '',
      categories: ['global', 'candidates'],
      category: '',
    }
  },
  created() {
    this.getAgents()
  },
  methods: {
    getAgents() {
      axios.get('/api/people/?is_agent=true&agency='+this.$store.getters.agencyID.toString())
        .then(res => {
          console.log(res)
          this.agents = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setteam(user) {
      axios.patch('/api/people/'+user.id.toString()+'/', {
        status: 'team'
      })
        .then(res => {
          console.log(res)
          this.getAgents()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAgentModal(agent) {
      this.agent = agent
      this.tab = 'admin'
      this.$modal.show('admin-panel-modal')
    },
    showAddAdminModal() {
      this.email = ''
      this.category = ''
      this.$modal.show('add-admin-modal')
    },
    unadminify(user) {
      //
      // Function for converting an admin account into a candidate account (just a workaround, not in production use)
      //
      axios.patch('/api/people/'+user.id.toString()+'/', {
        is_agent: false,
        is_candidate: true,
      })
        .then(res => {
          console.log(res)
          this.getAgents()
        })
        .catch(error => {
          console.log(error)
        })
    },
    setCategory(user) {
      axios.patch('/api/people/'+user.id.toString()+'/', {
        category: 'global'
        // category: 'candidates'
      })
        .then(res => {
          console.log(res)
          this.getAgents()
        })
        .catch(error => {
          console.log(error)
        })
    },
    addAdmin() {
      axios.post('/create-user/', {
        email: this.email,
        password: this.email,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
            {
              agency: this.$store.getters.agencyID,
              agency_owner: this.$store.getters.agencyName,
              // user_type: authData.user_type,
              // is_employer: this.is_employer,
              // is_candidate: this.is_candidate,
              is_agent: true,
              // status: 'New',
              // status: authData.status,
              // numberArray: [0, 0, 0, 0],
              category: this.category,
              first_name: this.firstName,
              last_name: this.lastName,
            }
          )
            .then(res => {
              console.log(res)

              this.getAgents()
              this.$modal.hide('add-admin-modal')
            })
            .catch(error => console.log(error))
        })
    },
    setPassword(user) {
      axios.post('/optimum/manual-reset-password/', {
        user_id: user.id,
        password: 'ChyanneRox@2020',
      })
        .then(res => {
          console.log(res)
          // this.$modal.show('password-reset-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showDeleteUserModal(user) {
      this.agent = user
      this.$modal.show('delete-agent-modal')
    },
    hideDeleteUserModal() {
      this.$modal.hide('delete-agent-modal')
    },
    deleteUser(user) {
      console.log('Deleting User: '.concat(user.id.toString()))
      axios.delete('/api/people/'.concat(user.id.toString()).concat('/'))
        .then(res => {
          console.log(res)
          // if (user.is_candidate) {
          //   this.getCandidates()
          // }
          // else if (user.is_employer) {
          //   this.getEmployers()
          // }
          this.getAgents()

          // this.hideDeleteModal()
          // this.closeCandidateModal()
          // this.$modal.hide('candidate-modal')
          this.$modal.hide('admin-panel-modal')
          this.hideDeleteUserModal()
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/tables/Agents.vue